import React, { useState } from "react";
import {
  decrypt,
  encrypt,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
  toastsuccessmsg2,
} from "../../helpers/Reusable";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import AuthBg from "./AuthBg";
import * as Yup from "yup";
import { useFormik } from "formik";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import ClipLoader from "react-spinners/ClipLoader";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { ToastContainer } from "react-toastify";
import { getCookie, setCookie } from "../../helpers/CookieComponent";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValues = {
  email: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email Is Not Valid"
    ),
});

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        email: values.email,
      };

      const response = await postData(
        "user/forget/password",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg2(response.data.message,5000);
        setTimeout(() => {
          setLoading(false);
          navigate("/forgotconfirm", {
            state: {
              userId: response.data.data.userId,
              email: values.email,
            },
          });
          resetForm();
        }, 5000);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <div className="flex flex-col lg:flex-row lg:justify-end lg:min-h-[85vh] xl:min-h-screen h-max">
        {/* Background Section */}
        <div className="h-auto lg:h-screen z-[1] relative lg:fixed top-0 left-0 lg:w-[40%]">
          <AuthBg />
        </div>
        <div className="lg:w-[60%] pt-[10%] pb-[20%] md:py-[10%] lg:py-[5%] px-[5%] md:px-[10%] bg-yellow">
          <div className="flex flex-col lg:flex-row w-full p-10">
            <div className="flex items-center justify-center flex-col lg:flex-row w-full">
              <div className="w-full lg:w-[500px]">
                <h1 className="mb-[5rem] auth-title-y">Forgot password</h1>
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full flex flex-col mb-[15rem]">
                    <label htmlFor="" className="w-full auth-input-label mb-4 required">
                      Enter registered email address
                    </label>
                    <input
                      className="w-full auth-input"
                      type="text"
                      placeholder="Enter email"
                      id="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="mt-2 error-msg">
                        <div className="">{formik.errors.email}</div>
                      </div>
                    )}
                  </div>
                  <div className="w-full justify-center lg:justify-start gap-5 flex">
                    <button
                      type="submit"
                      className="btn-auth"
                      disabled={loading}
                    >
                      {!loading && <>Send reset link</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
